import { appFormUtil } from 'modules/common';
import React, {
  useEffect,
  useState
} from 'react';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';
import {
  StyledDropDown,
  StyledTextField
} from 'modules';
import { IconButton } from '@mui/material';
import {
  Check,
  Close,
  Edit
} from '@mui/icons-material';



export type SelectPlanVersionFieldProps<T extends object, K extends keyof T = keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: K;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectPlanVersionFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.planId ?? '');
  const [
    fnSavePlanVersion,
    { loading, called }
  ] = ds.useSavePlanVersion();
  const [
    isEditVisible,
    setIsEditVisible
  ] = useState(false);

  const [
    newLabel,
    setNewLabel
  ] = useState<string | null>(null);


  useEffect(() => {
    const initialVal = props.form.formState[props.fieldName];
    if (typeof initialVal === 'string' && newLabel === null) {
      setNewLabel(() => data.find((node) => node.id === props.form.formState[props.fieldName])?.displayName ?? '');
    }
    return () => {};
  }, [
    data,
    newLabel,
    isEditVisible,
    props.fieldName,
    props.form.formState
  ]);


  useEffect(() => {
    if (newLabel === null && !loading && called) {
      setNewLabel(() => data.find((node) => node.id === props.form.formState[props.fieldName])?.displayName ?? '');
    }
  }, [
    called,
    data,
    loading,
    newLabel,
    props.fieldName,
    props.form.formState
  ]);
  if (isEditVisible) {
    return (
      <StyledTextField.FC
        {...props.form.genFieldProps(props.fieldName)}
        value={newLabel}

        onChange={(e) => {
          setNewLabel(() => e.target.value);
        }}
        startAdornment={(
          <IconButton
            onClick={async () => {
              const tempId = props.form.formState[props.fieldName];
              if (newLabel && newLabel.length <= 5) {
                window.alert('Must be longer than 5 characters');
                return;
              }
              if (typeof tempId === 'string' && data.find((r) => r.id === tempId)?.displayName !== newLabel) {
                await fnSavePlanVersion({
                  id: tempId,
                  name: newLabel
                });
              }
              setNewLabel(() => null);
              setIsEditVisible(() => false);
            }}
          >
            <Check />
          </IconButton>
        )}
        endAdornment={(
          <IconButton onClick={() => setIsEditVisible(() => false)}>
            <Close
              color='error'
            />
          </IconButton>
        )}
      />
    );
  }

  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={[...data]}
      startAdornment={(
        <IconButton
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setNewLabel(() => null);
            setIsEditVisible(() => true);
          }}
        >
          <Edit />
        </IconButton>
      )}
    />
  );
};

